import AuthForgotPasswordSuccess from "./AuthForgotPasswordSuccess";

export default AuthForgotPasswordSuccess;
